import axiosInstance from "../../Config/axiosConfig";

export const getFaqs = async () => {
  try {
    const response = await axiosInstance.get('/user/faqs');
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};